export enum RESPONSE_TYPE {
    REJECT = 0,
    ACEEPT = 1,
    CANCEL = 3
}

export enum ORDER_TYPE {
    OI = 'OI',
    OT = 'OT',
    AC = 'AC'
}

export enum ORDER_STATUS_IDS {
    PENDING   = 1,
    CONFIRMED = 2,
    REJECTED  = 3,
    CANCELED  = 4
}

export enum MESSAGE_STATUS {
    SENDING = 1,
    SENT    = 2,
    READ    = 3,
    ERROR   = 4
}

export enum REQUEST_STATUS_IDS {
    NEW       = 1,
    OPEN      = 2,
    PENDING   = 3,
    FINALIZED = 4,
    POSTPONED = 5
}

export const REQUEST_STATUS_NAMES = {
    '1': 'Nueva',
    '2': 'Abierta',
    '3': 'Pendiente',
    '4': 'Finalizada',
    '5': 'Pospuesta'
}